/*
 * @Author: wangkg
 * @Date: 2022-08-02 16:53:27
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-10-31 14:36:44
 * @Description: js入口文件
 */
import {createApp} from 'vue';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import {ElMessageBox, ElMessage} from 'element-plus';
import 'element-plus/dist/index.css';
import * as echarts from 'echarts';
import {createRouter, createWebHistory} from 'vue-router';
import { createPinia } from 'pinia';
import UdpListTitle from './components/udp-list-title';
import './styles/index.scss';
import App from './App';
import store from './store';
import router from './router';
// import { initAppPath } from '@/utils/index';
import '@/components/move-path/shared';
import Directives from './directives';
// import GlobalMixin from './mixins/GlobalMixin';
import plugins from '@/components/index';
import Utils from './utils/utils';
import { request } from '@/apis/request';
import './utils/rem-adapter'; // 引入rem自适应方案
import RemPlugin from './plugins/rem-plugin'; // 引入rem插件
import GlobalUtilsPlugin from './plugins/global-utils'; // 引入全局工具插件
import dataCollectWebJsSdk from '../data-collect-web-js-sdk/data-collect-web-js-sdk'
import dataCollectWebJsSdkConfig from '../data-collect-web-js-sdk/data-collect-web-js-sdk-config'

// Vue.config.productionTip = false;

const app = createApp(App)
const pinia = createPinia()
app.config.globalProperties.$request = request;
app.config.globalProperties.$echarts = echarts;
app.use(ElementPlus,{
  locale:zhCn,
});
app.use(RemPlugin); // 注册rem插件
app.use(GlobalUtilsPlugin); // 注册全局工具插件
app.config.globalProperties.$confirm = ElMessageBox.confirm
app.config.globalProperties.$message = ElMessage
app.use(router);
// app.use(GlobalMixin);
app.use(Directives);
// app.use(formCreate);
app.use(plugins);
app.use(pinia);
app.use(store);
app.component('UdpListTitle', UdpListTitle);
// 开启全埋点
app.config.globalProperties.$DataCollectWebJsSdk = dataCollectWebJsSdk.getInstance(dataCollectWebJsSdkConfig)
app.config.globalProperties.$DataCollectWebJsSdk.start()

app.config.globalProperties.$DataCollectWebJsSdk.setCommonFieldsInfo({
  $app_name:'承销特征分析',
})
// const TOKEN =
//   'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJ1c2VyT2JqZWN0Ijp7ImF0dHJpYnV0ZXMiOnsiRVhURU5EX1VTRVJfSUQiOiJDeHR6ZngyIiwiVEVOQU5UX0lEIjoiZGVmYXVsdCIsImxhc3RJcCI6IjEwLjguMzcuMjUyIiwibGFzdExvZ2luIjoiMjAyNC0xMS0xMyAwNzo1Mzo0Ny43NjAiLCJtZW51dHlwZSI6ImRlZmF1bHQiLCJtb2JpbGUiOm51bGwsIm9yZ0NvZGUiOiJjZmFlIiwib3JnbGlzdCI6IjIxIiwicGFyZW50T3JnSWRzIjoiIiwicGN0aWQiOiIiLCJyb2xlQ29kZSI6ImNmYWVfc3RhZmYsY3h0emZ4LWFkbWluIiwicm9sZUxpc3QiOiIxMDE0LDQxMzkifSwic2Vzc2lvbklkIjpudWxsLCJ1bmlxdWVJZCI6IjNlNzYwMTEzNmU2YjRjNGFhNmFlYjU3YzNmODQ5MzQ3IiwidXNlcklkIjoiMjEyMjQ1NiIsInVzZXJNYWlsIjoiMTIzQDE2My5jb20iLCJ1c2VyTmFtZSI6Iui2hee6p-euoeeQhuWRmCIsInVzZXJPcmdJZCI6IjIxIiwidXNlck9yZ05hbWUiOiLljJfph5HmiYAiLCJ1c2VyUmVhbE5hbWUiOiLotoXnuqfnrqHnkIblkZgiLCJ1c2VyUmVtb3RlSVAiOm51bGx9LCJzdWIiOiJDeHR6ZngyIiwiaWF0IjoxNzMyMDgyODQ2LCJleHAiOjE3MzI2ODc2NDZ9.s-FZBO8lX7tHfqRCux74z8AM2cb9IQQSD-1QWVBUjvzOIrfi8CfUHWYSNARh9j6GDUrZmxkg1lEsgNbqikjFlPcQM51YXIpBwIUfmmUPnDTex2xBjNORWwBzeobP3rqBBEUc_LP2hZ_hbFsfb7OFp3GbQ6UquUEmugkcShA_2nQ';
// const TOKEN = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJ1c2VyT2JqZWN0Ijp7ImF0dHJpYnV0ZXMiOnsiRVhURU5EX1VTRVJfSUQiOiJDeHR6Zng1IiwiVEVOQU5UX0lEIjoiZGVmYXVsdCIsImxhc3RJcCI6IjEwLjguMzcuMjUyIiwibGFzdExvZ2luIjoiMjAyNC0xMS0yNiAwMjoxNzo1Ny40MzMiLCJtZW51dHlwZSI6ImRlZmF1bHQiLCJtb2JpbGUiOm51bGwsIm9yZ0NvZGUiOiJjZmFlIiwib3JnbGlzdCI6IjIxIiwicGFyZW50T3JnSWRzIjoiIiwicGN0aWQiOiIiLCJyb2xlQ29kZSI6ImNmYWVfc3RhZmYsY3h0emZ4LW9wZXJhdGUtenF6eCIsInJvbGVMaXN0IjoiNDE2MiwxMDE0In0sInNlc3Npb25JZCI6bnVsbCwidW5pcXVlSWQiOiI4ZTM4NWEzYTZiYzQ0MTY4OGUxZDI5YzQwMTI5ZmE0OCIsInVzZXJJZCI6IjIxMjQyNzciLCJ1c2VyTWFpbCI6IjEyM0AxNjMuY29tIiwidXNlck5hbWUiOiLov5DokKXkurrlkZjvvIjlgLrmnYPkuK3lv4PvvIkiLCJ1c2VyT3JnSWQiOiIyMSIsInVzZXJPcmdOYW1lIjoi5YyX6YeR5omAIiwidXNlclJlYWxOYW1lIjoi6L-Q6JCl5Lq65ZGY77yI5YC65p2D5Lit5b-D77yJIiwidXNlclJlbW90ZUlQIjpudWxsfSwic3ViIjoiQ3h0emZ4NSIsImlhdCI6MTc1MjcyMDEzMSwiZXhwIjoxNzUzMzI0OTMxfQ.XKmZeHcWLAiFlw1BdZ_EKj9KnRDdotOi-3h9kyDGT8HdjnzL3mbqz9rF6tWg7ByalFzJsLsFBHrD3f-LW5YDwuo8O7HzzQPnZMG7GJA8MJNO-C8Qp62JQcg56dUkyK73Fffa7zzP_wcU_11mGejl6bkOyvyDbfEHHiF8kXqZSW0'
const TOKEN = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJ1c2VyT2JqZWN0Ijp7ImF0dHJpYnV0ZXMiOnsiRVhURU5EX1VTRVJfSUQiOiJDeHR6ZngyIiwiVEVOQU5UX0lEIjoiZGVmYXVsdCIsImxhc3RJcCI6IjEwLjguMzcuMjUyIiwibGFzdExvZ2luIjoiMjAyNC0xMS0xMyAwNzo1Mzo0Ny43NjAiLCJtZW51dHlwZSI6ImRlZmF1bHQiLCJtb2JpbGUiOm51bGwsIm9yZ0NvZGUiOiJjZmFlIiwib3JnbGlzdCI6IjIxIiwicGFyZW50T3JnSWRzIjoiIiwicGN0aWQiOiIiLCJyb2xlQ29kZSI6ImNmYWVfc3RhZmYsY3h0emZ4LWFkbWluIiwicm9sZUxpc3QiOiIxMDE0LDQxMzkifSwic2Vzc2lvbklkIjpudWxsLCJ1bmlxdWVJZCI6IjM0NjA2OGNkMmE2ZTRhZWRiYzJjMDIwMGMyOWQ1M2U0IiwidXNlcklkIjoiMjEyMjQ1NiIsInVzZXJNYWlsIjoiMTIzQDE2My5jb20iLCJ1c2VyTmFtZSI6Iui2hee6p-euoeeQhuWRmCIsInVzZXJPcmdJZCI6IjIxIiwidXNlck9yZ05hbWUiOiLljJfph5HmiYAiLCJ1c2VyUmVhbE5hbWUiOiLotoXnuqfnrqHnkIblkZgiLCJ1c2VyUmVtb3RlSVAiOm51bGx9LCJzdWIiOiJDeHR6ZngyIiwiaWF0IjoxNzU4NTEwOTI4LCJleHAiOjE3NTkxMTU3Mjh9.bx1WQlGMbuaG2P4u9cqrmw5bEjiTi51NxA06l8YB2ZnYmdoos7AzCFQckPmhq_r9xl2QlrXoDg831fTZrSTZYEh24qIpvPgeoPIDInVbnP-vgQ_PNG4HLzHlpsj7XR_o7hImGbwUOrhtfaYxVWgknu50zUKYNdGZi6ov0sxnQqE'
 
// 引入svg
import './icons/index';
let instance = null;
function isCenter() {
  let urlType = Utils.getUrlParam().urlType || sessionStorage.getItem('URL_TYPE');
  if (urlType === 'center') {
    return true;
  } else {
    return false;
  }
}
function isLogin() {
  return new Promise(async (resolve, reject) => {
    
    let token = Utils.getToken();
    let urlParam = Utils.getUrlParam();
    if (urlParam.urlType === 'center') {
      sessionStorage.setItem('URL_TYPE', 'center');
      sessionStorage.setItem('TOKEN', urlParam.token);
      await store.dispatch('user/updateUserInfo');
      resolve(true)
    }
    if (isCenter()) {
      token = sessionStorage.getItem('TOKEN');
    }
    // 开发环境不需登录 token本地写死
    // if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'testenviroment') {
    //   // document.cookie = `token=${TOKEN};path=/`;
    //   // await store.dispatch('user/updateUserInfo');
    //   resolve(true)
    // }
    // 先判断URL中是否含有token
    if (urlParam.token) {
      document.cookie = `token=${urlParam.token};path=/`;
      await store.dispatch('user/updateUserInfo');
      resolve(true)
    } else {
      // 判断COOKIE中是否含有token
      if (token) {
        resolve(true)
      } else {
        // if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'testenviroment') {
        //   window.location.href = '/uca/login'
        // }else if(process.env.NODE_ENV === 'production') {
        //   window.location.href = '/login'
        // }
        // window.location.href = process.env.VUE_APP_CFAE_NEWLOGIN
      //   this.$router.push({
      //     path: '/login',
      // })
        resolve(false)
      }
    }
  });
}
function isVisitor() {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      let userInfo = JSON.parse(localStorage.getItem('USER_INFO')) || {};
      let roleCodeList = userInfo.roleCode?.split(',') || [];
      let whiteRoleCodeList = process.env.VUE_APP_WHITE_ROLE.split(',') || [];
      const roleSet = new Set(roleCodeList);
      if (roleCodeList.length == 0 || !whiteRoleCodeList.some(item => roleSet.has(item))) {
        resolve(true);
      } else {
        resolve(false);
      }
    }, 0);
  });
}
//渲染函数
function render(props = {}) {
  const { container } = props;
  router.beforeEach(async(to, from, next) => {
    // if (to.meta.title) {
    //   document.title = to.meta.title;
    // }
    // if(to.path == '/login'){
    //   next()
    //   return
    // }
    await isLogin()
    // const loginResult = await isLogin()
    // if (loginResult) {
    //   const visitorResult = await isVisitor();
    //   if (visitorResult) {
    //     if (to.path == '/noneRole') {
    //       next();
    //     } else {
    //       next('/noneRole');
    //     }
    //   } else {
    //     next();
    //   }
    // } else {
    //   next('/login')
    // }
    next()
  });
  app.mount(container ? container.querySelector('#app') : '#app');
  //为了避免根 id `#app` 与其他的 DOM 冲突，需要限制查找范围
}
render();
